export default __webpack_public_path__ + "static/media/expo-todo.422432fd.png";